module.exports = __webpack_public_path__ + "static/media/vestum2.afa70019.png";